import {Injectable} from '@angular/core';

/**
 * Translations for customer address.
 */
@Injectable()
export class CustomerAddressTranslationsService {
  public i18nAddressTypeStandard: any = $localize`:@@customerAddresses.addressTypes.standard:Standard`;
  public i18nAddressTypeAdditional: any = $localize`:@@customerAddresses.addressTypes.additional:Additional`;
  public i18nAddressTypeDelivery: any = $localize`:@@customerAddresses.addressTypes.delivery:Delivery`;

  constructor() { }
}
